import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/themeThree/money.png'
import _imports_1 from '@/assets/firstRecharge/tittleLine.png'


const _hoisted_1 = { class: "offers_page" }
const _hoisted_2 = { class: "timer" }
const _hoisted_3 = {
  key: 0,
  class: "timeBox"
}
const _hoisted_4 = { class: "timeTitle" }
const _hoisted_5 = { class: "timer_countdown" }
const _hoisted_6 = {
  key: 0,
  class: "timer_box"
}
const _hoisted_7 = { class: "timer_box" }
const _hoisted_8 = { class: "timer_box" }
const _hoisted_9 = { class: "timer_box" }
const _hoisted_10 = {
  key: 1,
  class: "timeBox"
}
const _hoisted_11 = { class: "timeTitle" }
const _hoisted_12 = { class: "timer_countdown" }
const _hoisted_13 = {
  key: 0,
  class: "timer_box"
}
const _hoisted_14 = { class: "timer_box" }
const _hoisted_15 = { class: "timer_box" }
const _hoisted_16 = { class: "timer_box" }
const _hoisted_17 = { class: "promo_wrapper" }
const _hoisted_18 = { class: "promo_title" }
const _hoisted_19 = { class: "promo_title" }
const _hoisted_20 = { class: "promotion_card_list" }
const _hoisted_21 = { class: "bottom_text" }
const _hoisted_22 = { class: "rulePage" }

import { useRouter } from 'vue-router';
import CustomHeader from '../components/common/customHeader.vue';
import PromotionCard from './components/promotionCard.vue';
import { OffersView } from '@/view/offers/supportScript';

export default /*@__PURE__*/_defineComponent({
  __name: 'offersView',
  props: {
    dataSet: {}
  },
  setup(__props: any) {


const router = useRouter()
const props = __props

const getDayNameFromTimestamp = (timestamp: number): string => {
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", { weekday: "long" });
}
const routerchangeHandle = () => {
    router.push('/')
    localStorage.setItem('footerPopupOpen', '3')
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('offers.depositReturn')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "topImage" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: ""
          })
        ], -1)),
        (_ctx.dataSet.isActivityEnableTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('offers.remainTieTitle')), 1),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.dataSet.days > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createTextVNode(_toDisplayString(_ctx.dataSet.days > 0 ? _ctx.dataSet.days : ''), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.days')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.dataSet.hours), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('offers.hours')), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.dataSet.minutes), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('offers.minutes')), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_ctx.dataSet.seconds), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('offers.seconds')), 1)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('offers.untilStartPromoTitle')), 1),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.dataSet.days > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createTextVNode(_toDisplayString(_ctx.dataSet.days > 0 ? _ctx.dataSet.days : ''), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.days')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createTextVNode(_toDisplayString(_ctx.dataSet.hours), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('offers.hours')), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createTextVNode(_toDisplayString(_ctx.dataSet.minutes), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('offers.minutes')), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createTextVNode(_toDisplayString(_ctx.dataSet.seconds), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('offers.seconds')), 1)
                ])
              ])
            ])),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_van_row, { style: {"padding":"15px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "4",
                class: "centerAlign"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    width: "100%"
                  }, null, -1)
                ])),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "16",
                class: "centerAlign"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('offers.promotionTime')), 1),
                      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t(`offers.${getDayNameFromTimestamp(_ctx.dataSet.endTime)}`)), 1)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "4",
                class: "centerAlign"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    width: "100%"
                  }, null, -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityList, (item, index) => {
              return (_openBlock(), _createBlock(PromotionCard, {
                cardData: item,
                isActivityEnable: _ctx.dataSet.isActivityEnableTime,
                key: index,
                dayName: getDayNameFromTimestamp(_ctx.dataSet.endTime)
              }, null, 8, ["cardData", "isActivityEnable", "dayName"]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "24",
                class: "title"
              }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("img", { src: _imports_1 }, null, -1)),
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('common.activityTitle')), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("img", { src: _imports_1 }, null, -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityIntro, (value) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "line_text",
                key: value
              }, _toDisplayString(value), 1))
            }), 128))
          ])
        ])
      ])
    ])
  ], 64))
}
}

})